import type { Address } from 'fhir/r4';

/**
 * Assembles the flat form address fields into a FHIR `Address`.
 *
 * `type` is `Address['type']` rather than `string` because that is what the
 * result is assigned into; the only consumer (`patient/edit/utils`) passes the
 * literal `'physical'` at both call sites. `line` is always a two-element array
 * here even when either line is empty — the builder does not filter — which is
 * why the postal/physical addresses this produces carry a trailing `''`.
 */
const AddressBuilder = (
  type: Address['type'],
  address1: string,
  address2: string,
  city: string,
  state: string | undefined,
  postalCode: string,
  country: string
): Address => {
    const address = {
        type: type,
        line: [address1, address2],
        city: city,
        state: state,
        postalCode: postalCode,
        country: country,
    };
    return address;
}
export default AddressBuilder;
